import { Injectable, NgModule } from '@angular/core';
import { translationsHE } from '@authority-labs/constants';
import {
  TRANSLOCO_CONFIG,
  TRANSLOCO_LOADER,
  translocoConfig,
  TranslocoLoader,
  TranslocoModule
} from '@ngneat/transloco';
import { TranslocoLocaleModule } from '@ngneat/transloco-locale';
import { of } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class TranslocoHttpLoader implements TranslocoLoader {
  getTranslation() {
    return of(translationsHE);
  }
}

@NgModule({
  imports: [
    TranslocoLocaleModule.init({
      langToLocaleMapping: {
        he: 'he-IL'
      }
    })
  ],
  exports: [TranslocoModule],
  providers: [
    {
      provide: TRANSLOCO_CONFIG,
      useValue: translocoConfig({
        availableLangs: ['he'],
        defaultLang: 'he',
        reRenderOnLangChange: false,
        prodMode: environment.production,
        flatten: {
          aot: false
        }
      })
    },
    { provide: TRANSLOCO_LOADER, useClass: TranslocoHttpLoader }
  ]
})
export class TranslocoRootModule {}
